@if (!embedded) {
  <ion-header>
    <ion-toolbar color="primary">
      <ion-title>{{ task?.title }}</ion-title>
      <ion-buttons slot="start">
        <ion-back-button data-cy="task-details-back-button" defaultHref="tasks" text="" />
      </ion-buttons>
      @if (task !== null) {
        <ion-buttons slot="end">
          <ion-button (click)="toggleActionSheet()" data-cy="task-details-settings-button">
            <ion-icon name="settings-outline" slot="icon-only" />
          </ion-button>
        </ion-buttons>
      }
    </ion-toolbar>
  </ion-header>
}

<ion-content>

  @if (isLoading == true) {
    <div class="app-empty-state">
      <ion-spinner name="crescent"></ion-spinner>
      <p>{{ 'task.loadingTitle' | translate }}</p>
    </div>
  }

  @if (task !== null && isLoading == false) {
    <div class="app-page-container">

      @if (!embedded) {
        <div class="desktop-only edit-action">
          <ion-button (click)="navigateToEditTaskPage()" color="primary"
            data-cy="showreport-details-actionsheet-button">
            <ion-icon name="settings-outline" slot="start" />
            {{ 'task.editTitle' | translate }}
          </ion-button>
        </div>
      }

      <header class="app-meta-card">
        <h2 data-cy="task-details-title">{{ task.title }}</h2>
        <dl class="app-meta-grid">
          @if (task.priority !== null) {
            <div>
              <dt>{{ 'task.details.priorityLabel' | translate }}</dt>
              <dd>
                <ion-badge [color]="getPriorityColor(task.priority)" data-cy="task-details-priority">
                  {{ getPriorityString(task.priority) }}
                </ion-badge>
              </dd>
            </div>
          }
          <div>
            <dt>{{ 'task.details.submittedByLabel' | translate }}</dt>
            <dd>
              <ion-icon name="time-outline" />
              {{ task.submittedBy?.firstName }} {{ task.submittedBy?.lastName }}
            </dd>
          </div>
          <div>
            <dt>{{ 'task.details.submittedAtLabel' | translate }}</dt>
            <dd>{{ task.createdAt | date: 'dd MMMM - HH:mm' }}</dd>
          </div>
          @if (task.completedBy != null) {
            <div>
              <dt>{{ 'task.details.completedByLabel' | translate }}</dt>
              <dd>
                <ion-icon name="checkmark-outline" color="success" />
                {{ task.completedBy?.firstName }} {{ task.completedBy?.lastName }}
              </dd>
            </div>
            <div>
              <dt>{{ 'task.details.completedAtLabel' | translate }}</dt>
              <dd>{{ task.completedDateTime | date: 'dd MMMM - HH:mm' }}</dd>
            </div>
          }
        </dl>
      </header>

      @if (task.description && task.description.trim().length > 0) {
        <section class="app-section-card">
          <header class="app-section-header">
            <h3>{{ 'task.details.descriptionSection' | translate }}</h3>
          </header>
          <p class="task-description-body" data-cy="task-details-description">{{ task.description }}</p>
        </section>
      }

      @if (task.images?.length > 0) {
        <section class="app-section-card">
          <header class="app-section-header">
            <h3>{{ 'task.details.imagesSection' | translate }}</h3>
          </header>
          <app-picture-card-grid>
            @for (image of task.images; track image) {
              <app-picture-card
                (click)="showImageFullscreen(image.fileName)"
                [canFullscreen]="true"
                [canRemove]="false"
                [src]="getImageUrl(image.fileName)"
                />
            }
          </app-picture-card-grid>
        </section>
      }

      <section class="app-section-card" id="task-comments" tabindex="-1">
        <header class="app-section-header">
          <h3>{{ 'task.details.commentsSection' | translate }}</h3>
          <ion-badge color="medium" data-cy="task-details-comments-count">{{ task.comments.length }}</ion-badge>
        </header>
        @if (task.comments.length === 0) {
          <p class="task-comments-empty">{{ 'task.details.noComments' | translate }}</p>
        }
        @for (comment of task.comments; track comment.id) {
          <div class="task-comment-row">
            <ion-avatar class="task-comment-avatar">
              @if (getAvatarUrl(comment.submittedBy); as avatarUrl) {
                <img [src]="avatarUrl" [alt]="comment.submittedBy?.firstName">
              } @else {
                <ion-icon name="person-circle-outline" class="task-comment-avatar-placeholder" />
              }
            </ion-avatar>
            <div class="task-comment-body">
              <div class="task-comment-header">
                <span class="task-comment-author">{{ comment.submittedBy?.firstName }} {{ comment.submittedBy?.lastName }}</span>
                <span class="task-comment-time">{{ comment.updatedAt | date: 'dd MMMM - HH:mm' }}</span>
              </div>
              <div class="task-comment-text"
                [innerHtml]="comment.comment | highlighter:activeUser?.firstName:'full'">{{ comment.comment }}</div>
            </div>
          </div>
        }
      </section>

    </div>
  }

</ion-content>

<div class="task-comment-input-bar">
  <ion-textarea
    [(ngModel)]="taskCommentDto.comment"
    autocapitalize="sentences"
    clearInput="false"
    name="comment"
    [rows]=3
    (keyup.control.enter)="saveNewComment()"
    class="custom" />
    <ion-button [disabled]="isSavingComment || taskCommentDto.comment == null || taskCommentDto.comment.trim() == ''"
      (click)="saveNewComment()" style="border-left: 1px solid silver;" fill="clear" size="small" slot="end">
      @if (isSavingComment) {
        <ion-spinner name="crescent" slot="icon-only"></ion-spinner>
      } @else {
        <ion-icon name="send-outline" slot="icon-only" />
      }
    </ion-button>
  </div>
